export default {
    // 恢复为您的 Key
    key: '7MKBZ-OHOKL-DXOPP-EXZ4V-UC3FZ-JLF4R',
    referer: 'laoxie'
};
